<script lang="ts">
    import { clickOutside } from "../../helper"
    import Modal from "./Modal.svelte"

    export let open = false
    export let imageUrl: string
    export let downloadUrl: string = null
</script>

{#if open}
    <Modal show="{open}" size="lg">
        <!-- svelte-ignore a11y-click-events-have-key-events -->
        <div class="lightbox" on:click|stopPropagation tabindex="0" role="button">
            <div
                class="inner"
                use:clickOutside="{() => {
                    open = false
                }}"
            >
                <div class="image">
                    <img src="{imageUrl}" alt="" />
                </div>
                <!-- svelte-ignore a11y-click-events-have-key-events -->

                {#if downloadUrl}
                    <div class="download">
                        <a href="{downloadUrl}">
                            <span class="material-icons">file_download</span> Download
                        </a>
                    </div>
                {/if}
            </div>
        </div>
    </Modal>
{/if}
